import React, { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import { ProjectDto } from '@/core';
import { ErrorCard } from '@/components';
import {
  ProjectsConstructorLayout,
  ProjectsAddRolesForm,
  ProjectsRolesList,
  useNavigateConstructorTabs,
  validateRolesTab,
  ProjectConstructorNavigationControls,
} from '@/views';
import classes from './ProjectsRolesPage.module.scss';

export const ProjectsRolesPage = () => {
  const projectData = useOutletContext<ProjectDto>();
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const { navigateToNextTab } = useNavigateConstructorTabs(projectData);
  const isPositionsTabValid = validateRolesTab(projectData);
  const [isErrorNotification, setIsErrorNotification] = useState(false);

  useEffect(() => {
    isPositionsTabValid && setIsErrorNotification(false);
  }, [isPositionsTabValid]);

  const navigateToEmployeesTab = () => {
    if (!isPositionsTabValid) {
      setIsErrorNotification(true);
      return;
    }
    navigateToNextTab();
  };

  return (
    <ProjectsConstructorLayout
      projectData={projectData}
      content={
        <>
          <Typography.Title level={3}>
            {projectData?.name}: {t('addRoles.title')}
          </Typography.Title>
          <Typography.Text type="secondary" className={classes.pageDescription}>
            {t('addRoles.description')}
          </Typography.Text>
          <ProjectsAddRolesForm projectData={projectData} />
          {(projectData.isCompleted && !isPositionsTabValid) || isErrorNotification ? (
            <ErrorCard text={t('addRoles.invalidPage')} />
          ) : null}
          {projectData?.positions.length ? <ProjectsRolesList projectData={projectData} /> : null}
        </>
      }
      navigationControls={<ProjectConstructorNavigationControls navigateToNextTab={navigateToEmployeesTab} />}
    />
  );
};
